import { z } from "zod";
export const insightSeveritySchema = z.enum(["info", "warning", "critical"]);
export const insightCategorySchema = z.enum(["connection", "visit-behavior"]);
export const customerInsightDetailSchema = z.object({
    type: z.string(),
    severity: insightSeveritySchema,
    data: z.record(z.unknown()),
    category: insightCategorySchema,
});
export const customerInsightSchema = z.object({
    customerNumber: z.string(),
    customerName: z.string(),
    insights: z.array(customerInsightDetailSchema),
});
//# sourceMappingURL=customer-insight.schema.js.map